import {format, parseDateString} from './Date/Date.js';
import {rgData} from "./rgData/rg-data.js";
import {rgSearch} from "./rgSearch/rg-search.js";
import {rgNav} from "./rgNav/rg-nav.js";
import {rgDatetimepicker} from "./rgDatetimepicker/rg-datetimepicker.js";
import {rgSelectcontent} from "./rgSelectcontent/rg-selectcontent.js";
import {rgMap} from "./rgMap/rg-map.js";
import {rgQrcode} from "./rgQrcode/rg-qrcode.js";

Date.prototype.format = format;
Date.parseDateString = parseDateString;

customElements.define('rg-data', rgData, {extends: 'script'});
customElements.define('rg-search', rgSearch);
customElements.define('rg-nav', rgNav);
customElements.define('rg-datetimepicker', rgDatetimepicker);
customElements.define('rg-selectcontent', rgSelectcontent);
customElements.define('rg-map', rgMap);
customElements.define('rg-qrcode', rgQrcode);

Object.defineProperty(window.recon, 'rgElementsLoaded', {
    value: true,
    writable: false,
});